import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom"
import axios from "axios"

import ErrorMessage from '../components/elements/ErrorMessage'
import TextField from '../components/elements/form/TextField';
import PasswordField from '../components/elements/form/PasswordField';
import FormButton from '../components/elements/form/FormButton';
import { useDispatch } from 'react-redux';
import { ERROR } from '../store/types';
// import TimeSeriesChart from '../components/elements/charts/TimeSeriesChart';

const LoginPage = () => {
    let navigate = useNavigate()   
    const location = useLocation()
    const dispatch = useDispatch() 
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [processing, setProcessing] = useState(false)
    const [error, setError] = useState('')  

    const [validationErrors, setValidationErrors] = useState({})  

    const validateForm = () => {
        let errors = {}
        if(!email || email === '') {
            errors.email = true
        }
        if(!password || password === '') {
            errors.password = true
        }
        setValidationErrors(errors)

        return errors
    }
    
    const logIn = async  () => {
        const headers = {
            'Content-Type': 'application/json'
        }
        
        if (Object.values(validateForm()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        setProcessing(true)

        const requestPayload = { email, password }
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/sessions`, requestPayload, { headers })            

            localStorage.setItem("authToken", JSON.stringify(response.data.data.accessToken));
            getUserProfile(response.data.data.accessToken)
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    const getUserProfile = async  (token) => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/user/profile?expand=adminRoles`, { headers })
            if(response.data.data.userType === 'USER') {
                localStorage.removeItem("authToken");

                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'You do not have permission to access this platform'
                    }}}
                })
                
                setProcessing(false)
                return
            }           

            localStorage.setItem("userDetails", JSON.stringify(response.data.data));
            const userDetails = response.data.data

            // Get all permissions from user's admin roles
            const allPermissions = [];
            if (userDetails.adminRoles) {
                for (const role of userDetails.adminRoles) {
                    allPermissions.push(...role.permissions);
                }
            }

            localStorage.setItem("userPermissions", JSON.stringify(allPermissions));

            const returnUrl = new URLSearchParams(location.search).get('returnUrl')
            const destination = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
                ? returnUrl
                : '/admin'

            navigate(destination, { replace: true })
        } catch (error) {
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height
        }
    };

    // const generateSampleData = () => {
    //     const data = [];
    //     const startDate = new Date('2025-01-01');
    //     let currentValue = 95000;

    //     for (let i = 0; i < 365; i++) {
    //         const date = new Date(startDate);
    //         date.setDate(date.getDate() + i);

    //         // Simulate random daily fluctuations
    //         const change = Math.random() * 4000 - 2000; // Between -2000 and +2000
    //         currentValue += change;

    //         // Introduce a spike on March 22 (like the image)
    //         if (date.toISOString().startsWith('2025-03-22')) {
    //         currentValue = 142200.92;
    //         }

    //         // Clamp value between 85k and 160k
    //         currentValue = Math.max(85000, Math.min(160000, currentValue));

    //         data.push({
    //         date: date.toISOString(),
    //         value: Math.round(currentValue),
    //         });
    //     }

    //     return data;
    // };
    // const sampleData = generateSampleData();

    return (
        <div className="relative flex flex-row w-full">            
            {getWindowDimensions().width < 800 && 
            <div className='w-full absolute bg-black bg-opacity-50 h-screen z-50 flex items-center justify-center'>
                <div className='bg-primary rounded-lg p-10 w-10/12 resolution-warning'>
                    <p className='text-2xl text-accent mb-5'>Low resolution detected</p>
                    <p className='text-md'>For best performance and experience, kindly log in from a computer screen</p>
                </div>
            </div>
            }
            <div className="w-1/2 min-h-screen flex items-center justify-center mx-auto">
                <div className="w-3/6">
                    <h1 className="text-xl font-thin text-primary mb-1 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>

                    <h3 className="font-medium text-primary text-lg mb-4">Admin Platform</h3>
                    <p className="">Please provide your email address and password to proceed to the administrator dashboard</p>

                    <div className='mt-4'>
                        <TextField
                            inputLabel="Email address" 
                            fieldId="username" 
                            inputType="text" 
                            preloadValue={''}
                            inputPlaceholder={`Your registered email address`}
                            hasError={validationErrors && validationErrors.username} 
                            returnFieldValue={(value)=>{setEmail(value)}}
                        />
                    </div>
                    
                    <div className='mt-4'>
                        <PasswordField
                            inputLabel="Password" 
                            fieldId="password" 
                            inputType="password" 
                            inputPlaceholder="Your password"
                            preloadValue={''}
                            hasError={validationErrors && validationErrors.password} 
                            returnFieldValue={(value)=>{setPassword(value)}}
                        />
                    </div>

                    <p className="my-3 text-sm text-opacity-70 block">Forgot your password? <Link to="/password-reset" className="text-secondary">Click here to reset it</Link></p>
                    
                    <div className='mt-8'>
                        <FormButton buttonLabel="Login to your account" buttonAction={()=>{logIn()}} processing={processing} />
                    </div>

                    {error && error!=='' &&  
                        <ErrorMessage message={error} dismissHandler={()=>{setError(false)}} />
                    }
                </div>
            </div>
            <div className="w-1/2 h-screen bg-gray-50 flex items-center justify-center relative">
                {/* <h1 className="text-4xl text-secondary font-bold mb-5 font-wix-mf-display">Benue State Judiciary</h1> */}
                {/* <div className=''> */}
                    {/* <TimeSeriesChart
                        data={sampleData}
                        currencySymbol="₦"
                        hideYAxisLabels={true}
                        lineColor="#05CB2C"
                        gradientColor="rgba(5, 203, 44, 0.1)"
                    /> */}
                {/* </div> */}
            </div>
        </div>
    )
}

export default LoginPage
